(() => {
  'use strict';
  const t = (key, values = {}, fallback = key) => window.NLV?.i18n?.t(key, values, fallback) ?? String(fallback).replace(/\{([a-zA-Z_][\w]*)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
  if (window.NLVPrivacy) return;
  const purposes = ['preferences', 'analytics', 'marketing'];
  let api, loading, sdkTimer, waitingTimer, observer, standalonePreviousFocus, standaloneOverflow = '', ready = false, nativeHandled = false, nativeWasVisible = false, autoRequested = false, saved = false;
  const marker = document.querySelector('[data-nlv-privacy]');
  const panels = () => [...document.querySelectorAll('[data-cookie-choices]')];
  const homeDialog = () => document.querySelector('[data-marketing-dialog]:has([data-cookie-choices])');
  const standalone = () => document.querySelector('[data-cookie-dialog]');
  const visible = element => Boolean(element && !element.hidden && element.getClientRects().length && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
  const nativeVisible = () => [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')].some(visible);
  const consent = () => { try { return api?.currentVisitorConsent() || {}; } catch (_) { return {}; } };
  const needsChoice = () => {
    if (!api) return false;
    const current = consent();
    let configured = false; try { configured = api.shouldShowBanner(); } catch (_) {}
    return configured || purposes.every(purpose => !['yes', 'no'].includes(current[purpose]));
  };
  const canEmbed = () => {
    if (!api || consent().marketing === 'no') return false;
    try { return typeof api.marketingAllowed !== 'function' || api.marketingAllowed(); } catch (_) { return false; }
  };
  const emit = () => document.dispatchEvent(new CustomEvent('nlv:privacy:ready'));
  function sync(message = '') {
    const current = consent();
    panels().forEach(panel => {
      panel.querySelectorAll('[data-cookie-accept],[data-cookie-reject],[data-cookie-preferences],[data-cookie-save]').forEach(button => { button.disabled = !api || saved; });
      panel.querySelectorAll('[data-cookie-purpose]').forEach(field => { field.checked = current[field.dataset.cookiePurpose] === 'yes'; field.disabled = !api || saved; });
      panel.querySelector('[data-cookie-status]').textContent = message || (!ready ? t('privacy.loading', {}, "Loading cookie settings…") : !api ? t('privacy.unavailable', {}, "Cookie settings are unavailable. Your choices have not been changed.") : needsChoice() ? t('privacy.separate', {}, "Your cookie choice is separate from email or text signup.") : t('privacy.saved_status', {}, "Your cookie choices are saved. You can update them anytime."));
      panel.querySelector('[data-cookie-retry]').hidden = !ready || Boolean(api);
    });
  }
  function nativeChanged() {
    const displayed = nativeVisible();
    if (displayed) {
      nativeHandled = true;
      document.querySelectorAll('[data-marketing-dialog][open], [data-cookie-dialog][open]').forEach(dialog => { dialog.dataset.privacyYield = 'true'; dialog.close(); });
    }
    if (displayed !== nativeWasVisible) { nativeWasVisible = displayed; emit(); }
  }
  const busy = () => nativeVisible() || document.visibilityState !== 'visible' || Boolean(document.querySelector('[data-intro]:not([hidden]),dialog[open],[data-purchase-toast]:not([hidden])'));
  function open({ embeddedUrl = '' } = {}) {
    if (nativeVisible()) { document.querySelector('#shopify-pc__banner button,#shopify-pc__prefs button')?.focus(); return false; }
    panels().forEach(panel => {
      const note = panel.querySelector('[data-cookie-embed-note]'); note.hidden = !embeddedUrl;
      const link = panel.querySelector('[data-cookie-external]'); if (embeddedUrl) link.href = embeddedUrl; else link.removeAttribute('href');
    });
    if (homeDialog()) { document.dispatchEvent(new CustomEvent('nlv:privacy:open', { detail: { focusCookies: true } })); return true; }
    const dialog = standalone();
    if (!dialog || dialog.open || busy()) return false;
    standalonePreviousFocus = document.activeElement; standaloneOverflow = document.body.style.overflow;
    dialog.showModal(); document.body.style.overflow = 'hidden'; dialog.querySelector('[data-cookie-heading]')?.focus(); return true;
  }
  function attemptStandalone() {
    if (autoRequested && ready && needsChoice() && !nativeHandled && !window.Shopify?.designMode && !homeDialog() && !busy()) { autoRequested = false; open(); }
  }
  function load() {
    if (loading) return loading;
    ready = false; sync();
    loading = new Promise(resolve => {
      let finished = false, attempts = 0;
      const finish = error => {
        if (finished) return; finished = true; clearTimeout(sdkTimer); clearTimeout(waitingTimer);
        api = !error && typeof window.Shopify?.customerPrivacy?.setTrackingConsent === 'function' ? window.Shopify.customerPrivacy : undefined;
        ready = true; loading = undefined; sync(); nativeChanged(); emit(); attemptStandalone(); resolve(Boolean(api));
      };
      const install = () => {
        if (typeof window.Shopify?.customerPrivacy?.setTrackingConsent === 'function') { finish(); return; }
        if (typeof window.Shopify?.loadFeatures === 'function') {
          try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], finish); } catch (_) { finish(true); }
        } else if (++attempts < 40) waitingTimer = setTimeout(install, 100);
        else finish(true);
      };
      sdkTimer = setTimeout(() => finish(true), 8000); waitingTimer = setTimeout(install, 0);
    });
    return loading;
  }
  function save(panel, values) {
    if (!api || saved) return;
    saved = true; sync(t('privacy.saving', {}, "Saving your cookie choices…"));
    let finished = false;
    const finish = error => {
      if (finished) return; finished = true; clearTimeout(timeout); saved = false;
      const actual = consent();
      const recorded = !error && purposes.every(purpose => actual[purpose] === (values[purpose] ? 'yes' : 'no'));
      sync(recorded ? t('privacy.saved', {}, "Cookie choices saved.") : t('privacy.failed', {}, "We couldn’t save your cookie choices. Please try again."));
      if (recorded) panel.closest('dialog')?.close();
      emit();
    };
    const timeout = setTimeout(() => finish(true), 8000);
    try { api.setTrackingConsent(values, finish); } catch (_) { finish(true); }
  }
  window.NLVPrivacy = { get ready() { return ready; }, get nativeHandled() { return nativeHandled; }, nativeVisible, needsChoice, canEmbed, open, load };
  document.addEventListener('click', event => {
    const manual = event.target.closest('[data-open-cookie-preferences]');
    if (manual) { event.preventDefault(); open(); if (!api && ready) load(); return; }
    const panel = event.target.closest('[data-cookie-choices]');
    if (!panel) return;
    if (event.target.closest('[data-cookie-retry]')) { event.preventDefault(); load(); return; }
    if (event.target.closest('[data-cookie-preferences]')) {
      const options = panel.querySelector('[data-cookie-options]'); options.hidden = !options.hidden;
      panel.querySelector('[data-cookie-preferences]').setAttribute('aria-expanded', String(!options.hidden)); return;
    }
    let values;
    if (event.target.closest('[data-cookie-accept]')) values = Object.fromEntries(purposes.map(purpose => [purpose, true]));
    if (event.target.closest('[data-cookie-reject]')) values = Object.fromEntries(purposes.map(purpose => [purpose, false]));
    if (event.target.closest('[data-cookie-save]')) values = Object.fromEntries([...panel.querySelectorAll('[data-cookie-purpose]')].map(field => [field.dataset.cookiePurpose, field.checked]));
    if (values) { event.preventDefault(); save(panel, values); }
  });
  // Capture before the video section can create an Instagram iframe or load its SDK.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-video-open]'); if (!button) return;
    const template = button.closest('[data-video-card]')?.querySelector('[data-video-template]');
    const url = template?.content.querySelector('[data-instagram-permalink]')?.dataset.instagramPermalink;
    if (!/^https:\/\/www\.instagram\.com\/(?:reel|p)\/[A-Za-z0-9_-]+\/$/.test(url || '') || canEmbed()) return;
    event.preventDefault(); event.stopImmediatePropagation(); open({ embeddedUrl: url });
  }, true);
  const cookieDialog = standalone();
  cookieDialog?.querySelector('[data-cookie-close]')?.addEventListener('click', () => cookieDialog.close());
  cookieDialog?.addEventListener('click', event => { if (event.target === cookieDialog) { const rect = cookieDialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) cookieDialog.close(); } });
  cookieDialog?.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) { document.body.style.overflow = standaloneOverflow; standalonePreviousFocus?.focus(); } });
  document.addEventListener('visitorConsentCollected', () => { sync(); nativeChanged(); if (!canEmbed()) document.querySelectorAll('[data-instagram-permalink]').forEach(player => { player.closest('dialog[open]')?.close(); player.querySelectorAll('iframe').forEach(frame => frame.remove()); }); emit(); });
  document.addEventListener('visibilitychange', attemptStandalone);
  document.addEventListener('shopify:section:load', () => { sync(); emit(); });
  observer = new MutationObserver(() => { nativeChanged(); attemptStandalone(); });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'open', 'style', 'class'] });
  if (marker) { setTimeout(() => { autoRequested = true; attemptStandalone(); }, Math.max(0, 6000 - performance.now())); load(); }
})();
